import React from "react";
import Select from "react-select";
import { salesWorkTypeOptions, salesWorkSubTypeOptions } from "@/constants/selectOptions";

export const FormPartner = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>종사자 유형</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={salesWorkTypeOptions}
                            isSearchable
                            placeholder="상세 유형"
                            value={salesWorkTypeOptions?.find((opt) => opt.value === formData?.member?.salesPartnerInfo?.salesWorkType)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        salesPartnerInfo: {
                                            ...prev.member.salesPartnerInfo,
                                            salesWorkType: option?.value || null,
                                            salesWorkSubType: null,
                                        },
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>상세 유형</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={
                                formData?.member?.salesPartnerInfo?.salesWorkType
                                    ? salesWorkSubTypeOptions.filter((opt) => opt.type === formData?.member?.salesPartnerInfo.salesWorkType)
                                    : []
                            }
                            isSearchable
                            placeholder={
                                formData?.member?.salesPartnerInfo?.salesWorkType ? "상세 유형 선택" : "종사자 유형을 먼저 선택해주세요."
                            }
                            value={
                                salesWorkSubTypeOptions?.find(
                                    (opt) => opt.value === formData?.member?.salesPartnerInfo?.salesWorkSubType
                                ) || null
                            }
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        salesPartnerInfo: {
                                            ...prev.member.salesPartnerInfo,
                                            salesWorkSubType: option?.value || null,
                                        },
                                    },
                                }));
                            }}
                            isDisabled={!formData?.member?.salesPartnerInfo?.salesWorkType}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>업체명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.salesPartnerInfo.corpName"
                            placeholder="업체명"
                            value={formData?.member?.salesPartnerInfo?.corpName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>직함</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.salesPartnerInfo.position"
                            placeholder="직함"
                            value={formData?.member?.salesPartnerInfo?.position}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
